(function(window, document, $) {
  'use strict';

  let marker;
  let map;

  const maskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  },
  options = {onKeyPress: function(val, e, field, options) {
      field.mask(maskBehavior.apply({}, arguments), options);
    }
  };

  function showMessageFeedback({ type, message }) {
    const html = `
      <div class="message-feedback__content">
        <span class="message-feedback__close"><i class="icon-close"></i></span>
        <h3 class="message-feedback__title">${type === 'success' ? 'Sucesso!' : 'Erro!'}</h3>
        <p>${message}</p>
      </div>
    `;

    $('.message-feedback').html(html);

    setTimeout(function() {
      $('.message-feedback').addClass('is-active ' + type);
    }, 200);
  }

  function changeLoaderVisibility(visible) {
    if (visible) {
      $('body').addClass('show-loader');
    } else {
      $('body').removeClass('show-loader');
    }
  }

  function ajaxContentWrapper({ e = {}, url, method = 'GET', dataType = null, formData = null, callbackSuccess = (data) => { console.log(data)}, callbackError = (data) => { console.log(data) }, timeout = 0 }) {
    $.ajax({
      url,
      method,
      dataType,
      data: formData,
      beforeSend: function() {
        changeLoaderVisibility(true);
      },
      success: function(data) {
        callbackSuccess(data);
      },
      error: function(data) {
        callbackError(data);
      },
      complete: function() {
        changeLoaderVisibility(false);
      }
    });
  }

  $(document).ready(() => {
    $('.phone').mask(maskBehavior, options);
    const homeSlideshow = $('.home-slideshow');

    homeSlideshow.on('init', function(slick) {
      $('.home-slideshow .slick-slide[data-slick-index="0"]').addClass('animate');
    });

    homeSlideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.home-slideshow .slick-slide').removeClass('animate');
    });

    homeSlideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.home-slideshow .slick-slide').removeClass('animate');
      $('.home-slideshow .slick-slide[data-slick-index="' + currentSlide + '"]').addClass('animate');
    });

    homeSlideshow.slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      verticalSwiping: false,
      vertical: true
    });

    $('.machines__slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 3,
      variableWidth: true
    });

    $('.services__slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 1,
      variableWidth: true
    });

    $('.testimonials__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 1
    });

    $('.works-slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 3,
      variableWidth: true,
      centerMode: $('.works-slider').parent().hasClass('related-works'),
    });

    $('.machines-slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 3,
      responsive: [{
          breakpoint: 770,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          }
      }]
    });

    $('.clients__grid').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 1,
      variableWidth: true,
      responsive: [{
        breakpoint: 99999,
        settings: 'unslick'
      },{
          breakpoint: 770,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          }
      }]
    });

    $('.card-work__gallery').lightGallery({
      selector: 'span'
    });

    $('.card-work__link').click(function() {
      $(this).closest('.card-work').find('.card-work__gallery span').trigger('click');
    });

    $('.js-quick-quote').click(function() {
      $('.quick-quote').addClass('is-active');
    });

    $('.quick-quote__close').click(function() {
      $('.quick-quote').removeClass('is-active');
    });

    $('.quick-quote').click(function(e) {
      const target = e.target;

      if ($(target).is($('.quick-quote'))) {
        $('.quick-quote').removeClass('is-active');
      }
    });

    $('.card-service__link').click(function(e) {
      e.preventDefault();
      const service = $(this).data('service');

      $('.quick-quote select[name="cf_service"]').val(service);
      $('.js-quick-quote').trigger('click');
    });

    $('.menu-trigger').click(function() {
      const header = $('.header');
      const isOpened = header.hasClass('is-opened');

      if (isOpened) {
        header.removeClass('is-opened');
        $('html, body').css('overflow', 'auto');
      } else {
        header.addClass('is-opened');
        $('html, body').css('overflow', 'hidden');
      }
    });

    $('.toolbar-trigger').click(function() {
      $('.toolbar-nav').toggleClass('is-active');
    });

    $('.timeline').click(function() {
      $('.timeline').removeClass('is-active');
      $(this).addClass('is-active');
    });

    $('.gallery-active').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.gallery-nav'
    });

    $('.gallery-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.gallery-active',
      dots: false,
      centerMode: false,
      focusOnSelect: true
    });

    if ($('#map').length) {
      const coordinates = $('#map').data('coordinates');
      const [ lat, lon ] = coordinates.split(',');

      map = L.map('map', {
        center: [lat, lon],
        zoom: 16,
        // zoomControl: false,
        scrollWheelZoom: false,
      });

      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: '',
        maxZoom: 16
      }).addTo(map);

      let markerIcon = L.icon({
        iconUrl: themeUrl + '/public/images/marker.png',
        iconSize: [182, 182],
        iconAnchor: [90, 90]
      });

      marker = L.marker([lat, lon], { icon: markerIcon })
        .addTo(map);
    }

    $('.toolbar-item a').click(function(e) {
      e.preventDefault();
      const category = $(this).attr('href').split('#')[1];
      const parent = $(this).parent();
      $('.listing__grid > div').show();

      if (parent.hasClass('is-current')) {
        parent.removeClass('is-current');
      } else {
        $('.toolbar-item').removeClass('is-current');
        parent.addClass('is-current');

        $('.listing__grid > div').each(function() {
          const currentCategory = $(this).data('category');

          if (category != currentCategory) {
            $(this).hide();
          }
        })
      }
    });

    $('.message-feedback').on('click', function(e){
      const target = $(e.target);

      if(target.hasClass('is-active') || target.is('.icon-close')) {
        $('.message-feedback').removeClass('is-active success error');

        setTimeout(() => {
          $('.message-feedback').empty();
        }, 1500)
      }
    });

    $('.newsletter__form, .contact__form, .quick-quote__form, .service__quote, .machine__quote').submit(function(e) {
      e.preventDefault();
      const form = $(this);
      const url = form.attr('action');
      const formData = form.serialize();

      console.log(formData);

      ajaxContentWrapper({
        url,
        formData,
        method: 'POST',
        callbackSuccess: (data) => {
          showMessageFeedback({
            type: data.success ? 'success' : 'error',
            message: data.data
          });

          if (data.success) {
            form[0].reset();

            if (form.is('.quick-quote__form')) {
              $('.quick-quote__close').trigger('click')
            }
          }
        },
        callbackError: (error) => {
          console.error(error);
          showMessageFeedback({
            type: 'error',
            message: error.data ? error.data : 'Erro ao enviar mensagem.'
          })
        }
      })
    });

  });

  $(window).scroll(() => {

  });

  $(window).resize(() => {

  });

})(window, document, jQuery);
